export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13342.343e1424.jpg";